/* eslint-disable no-restricted-imports */
import {
  createPathSelector, createPropSelector, defaultKeySelector, createBoundSelector,
  stringComposeKeySelectors, createChainSelector, createEmptySelector,
  ChainSelectorOptions, initGarbageCollector,
} from '@anwhy/reselect-utils';
import { Selector, ParametricSelector, ICacheObject, createCachedSelector as originCachedSelector } from 're-reselect';

export {
  createPathSelector as path,
  createPropSelector as prop,
  createBoundSelector as bound,
  createChainSelector as chain,
  createEmptySelector as empty,
  defaultKeySelector,
  stringComposeKeySelectors,
  initGarbageCollector,
};

export type { ChainSelectorOptions, Selector, ParametricSelector, ICacheObject };

export const createCachedSelector = originCachedSelector;
